/* eslint-disable
    eqeqeq,
    @typescript-eslint/no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { importWithRetry } from '@trello/use-lazy-component';
import React from 'react';
import { Auth } from 'app/scripts/db/Auth';
import { pluginRunner } from 'app/scripts/views/internal/plugins/PluginRunner';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { PluginHeaderButtonsView } from 'app/scripts/views/plugin/PluginHeaderButtonsView';
// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { Dialog } from 'app/scripts/views/lib/Dialog';
import { Analytics } from '@trello/atlassian-analytics';
import { PremiumFeature } from '@trello/product-features';
import { WindowSize } from 'app/scripts/lib/window-size';
import { DirectoryView } from 'app/scripts/views/directory/DirectoryView';
import ReactDOM from '@trello/react-dom-wrapper';
import {
  sendPluginUIEvent,
  sendPluginScreenEvent,
} from 'app/scripts/lib/plugins/plugin-behavioral-analytics';
import { LegacyPowerUps } from 'app/scripts/data/legacy-power-ups';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { renderPluginDropdownList } from 'app/src/components/PluginHeaderButton/renderPluginDropdownList';
import { renderPluginHeaderButtons } from 'app/src/components/PluginHeaderButton/renderPluginHeaderButtons';
import { CalendarBoardButton } from 'app/scripts/views/board/CalendarBoardButton';
import { navigate } from 'app/scripts/controller/navigate';
import { isUrl } from '@trello/urls';
import { Urls } from 'app/scripts/controller/urls';
const { getBoardUrl } = Urls;

import { PluginViewView } from 'app/scripts/views/plugin/PluginViewView';
import { BUTLER_POWER_UP_ID } from 'app/scripts/data/butler-id';
import {
  customFieldsId as CUSTOM_FIELDS_ID,
  mapPowerUpId as MAP_POWER_UP_ID,
} from '@trello/config';
import { GlobalThemeObserver } from '@trello/theme';
const CALENDAR_POWER_UP_ID = LegacyPowerUps.calendar;

export const reloadCustomFields = function () {
  if (this.model.isPluginEnabled(CUSTOM_FIELDS_ID)) {
    // we need to give the server a second to prevent any race conditions
    // mainly if we were the ones to enable custom fields
    return setTimeout(() => {
      return ModelLoader.loadCustomFields(this.model.id);
    }, 1000);
  }
};

export const renderPluginButtons = function () {
  if (this.pluginHeaderButtonsView != null) {
    this.pluginHeaderButtonsView.requestButtonsDebounced();
  } else {
    this.pluginHeaderButtonsView = this.subview(
      PluginHeaderButtonsView,
      this.model,
    );
  }
  this.appendSubview(
    this.pluginHeaderButtonsView,
    $('.js-plugin-header-btns', this.$el),
  );

  return this;
};

export const renderBoardHeaderCalendar = function (options) {
  if (options == null) {
    options = {};
  }
  const container = $('.js-calendar-board-btn', this.$el);
  if (!container.length) {
    return;
  }

  const isCalendarEnabled = this.model.isPowerUpEnabled('calendar');
  container.toggleClass('hide', !isCalendarEnabled);
  if (isCalendarEnabled) {
    return renderComponent(
      <CalendarBoardButton
        // eslint-disable-next-line react/jsx-no-bind
        onClick={() => {
          sendPluginUIEvent({
            idPlugin: LegacyPowerUps.calendar,
            idBoard: this.model.id,
            event: {
              action: 'clicked',
              actionSubject: 'button',
              actionSubjectId: 'powerUpBoardButton',
              source: 'boardScreen',
            },
          });
          return this.toggleCalendar();
        }}
      />,
      container[0],
    );
  }
};

const _renderPluginHeaderButtons = function () {
  return renderPluginHeaderButtons(
    this.el.querySelector('.js-pup-header-btns'),
    this.model,
    () => {
      const directoryUrl = getBoardUrl(this.model.id, 'power-ups/enabled');
      navigate(directoryUrl, { trigger: true });
      if (!WindowSize.fExtraLarge) {
        return this.sidebarView.hideSidebar();
      }
    },
    () => {
      return this.toggleDirectory();
    },
    //openPluginSettings() -- opens the directory to the plugins directory page
    (pluginId) => {
      const directoryUrl = getBoardUrl(this.model.id, `power-up/${pluginId}`);
      navigate(directoryUrl, { trigger: true });
      if (!WindowSize.fExtraLarge) {
        return this.sidebarView.hideSidebar();
      }
    },
  );
};
export { _renderPluginHeaderButtons as renderPluginHeaderButtons };

const _renderPluginDropdownList = function () {
  return renderPluginDropdownList(
    this.el.querySelector('.js-pup-dropdown-list-btn'),
    this.model,
    () => {
      const directoryUrl = getBoardUrl(this.model.id, 'power-ups/enabled');
      navigate(directoryUrl, { trigger: true });
      if (!WindowSize.fExtraLarge) {
        return this.sidebarView.hideSidebar();
      }
    },
    () => {
      return this.toggleDirectory();
    },
    //openPluginSettings() -- opens the directory to the plugins directory page
    (pluginId) => {
      const directoryUrl = getBoardUrl(this.model.id, `power-up/${pluginId}`);
      navigate(directoryUrl, { trigger: true });
      if (!WindowSize.fExtraLarge) {
        return this.sidebarView.hideSidebar();
      }
    },
  );
};
export { _renderPluginDropdownList as renderPluginDropdownList };

export const unmountPluginDropdownList = function () {
  const reactRoot = this.el.querySelector('.js-pup-dropdown-list-btn');
  if (reactRoot) {
    return ReactDOM.unmountComponentAtNode(reactRoot);
  }
};

export const unmountPluginHeaderButtons = function () {
  const reactRoot = this.el.querySelector('.js-pup-header-btns');
  if (reactRoot) {
    return ReactDOM.unmountComponentAtNode(reactRoot);
  }
};

export const navigateToBoard = function () {
  const boardUrl = Controller.getBoardUrl(this.model.id);
  return navigate(boardUrl, { trigger: true });
};

export const closeDetailView = function () {
  Dialog.hide(true);
  this.closeCalendar(false);
  this.closeDirectory(false);
  this.closeMap(false);
  this.closeButler(false);
  this.closeSingleBoardView();
  this.closePowerUpView(false);
};

export const clickCloseDirectory = function () {
  if (this.directoryView) {
    Analytics.sendClickedButtonEvent({
      buttonName: 'boardDirectoryCloseButton',
      attributes: {
        boardId: this.model.id,
        organizationId: this.model.get('idOrganization'),
      },
      source: this.directoryView.activeEventSource(),
    });
  }

  return this.toggleDirectory();
};

export const toggleDirectory = function () {
  if (this.directoryView) {
    if (this.directoryReturnCard) {
      this.closeDirectory(false);
      Controller.showCardDetail(this.directoryReturnCard);
      return (this.directoryReturnCard = null);
    } else {
      return this.navigateToBoard();
    }
  } else {
    return this.navigateToDirectory();
  }
};

export const navigateToDirectory = function (returnCard) {
  const directoryUrl = Controller.getBoardUrl(this.model.id, 'power-ups');
  navigate(directoryUrl, { trigger: true });

  this.directoryReturnCard = returnCard;

  // Close the sidebar menu for window sizes that aren't extra large.
  if (!WindowSize.fExtraLarge) {
    return this.sidebarView.hideSidebar();
  }
};

export const showDirectory = function (
  section,
  category,
  idPlugin,
  isEnabling,
) {
  $('#board', this.$el).addClass('hide');

  this.directoryView = new DirectoryView({
    model: this.model,
    modelCache: this.modelCache,
    section,
    category,
    idPlugin,
    isEnabling,
    boardView: this,
  });
  return $('.js-board-view-container', this.$el).html(
    this.directoryView.render().el,
  );
};

export const closeDirectory = function (navigateToBoard) {
  if (navigateToBoard == null) {
    navigateToBoard = true;
  }
  if (this.directoryView != null) {
    this.directoryView.remove();
    this.directoryView = null;
    if (navigateToBoard) {
      this.navigateToBoard();
    }
    $('#board', this.$el).removeClass('hide');
    $('.js-list-name-input', this.$el).trigger('autosize.resize', false);
  }
};

export const toggleCalendar = function () {
  if (this.calendarView) {
    if (this.calendarReturnCard) {
      this.closeCalendar(false);
      Controller.showCardDetail(this.calendarReturnCard);
      return (this.calendarReturnCard = null);
    } else {
      return this.navigateToBoardEvent();
    }
  } else {
    return this.navigateToCalendarEvent();
  }
};

export const dismissFeedback = function () {
  Auth.me().setPluginDataByKey(
    CALENDAR_POWER_UP_ID,
    'private',
    'dismissedFeedback',
    true,
  );
  $('.calendar-header-toolbar-feedback', this.$el).addClass('hide');
};

export const navigateToCalendarEvent = function () {
  sendPluginScreenEvent({
    idPlugin: LegacyPowerUps.calendar,
    idBoard: this.model.id,
    screenName: 'calendarViewScreen',
  });
  return this.navigateToCalendar();
};

export const navigateToCalendar = function (returnCard) {
  this.calendarReturnCard = returnCard;
  const calendarBoardUrl = Controller.getBoardUrl(this.model.id, 'calendar');
  return navigate(calendarBoardUrl, { trigger: true });
};

export const navigateToBoardEvent = function () {
  return this.navigateToBoard();
};

export const isShowingCalendar = function () {
  return this.calendarView != null;
};

export const showCalendar = function (date) {
  if (!this.model.isPowerUpEnabled('calendar') || this.isShowingCalendar()) {
    return;
  }

  $('.calendar-btn', this.$el).addClass('board-header-btn-enabled');
  $('#board', this.$el).addClass('hide');

  return importWithRetry(() =>
    import(
      /* webpackChunkName: "calendar-controller-view" */ 'app/scripts/views/calendar/CalendarControllerView'
    ),
  ).then(({ CalendarControllerView }) => {
    this.calendarView = new CalendarControllerView({
      model: this.model,
      modelCache: this.modelCache,
    });
    $('.js-board-view-container', this.$el).html(
      this.calendarView.render(date).el,
    );
    this.calendarView.addedToDOM();

    return this.renderViewSwitcherDebounced();
  });
};

export const closeCalendar = function (navigateToBoard) {
  if (navigateToBoard == null) {
    navigateToBoard = true;
  }
  if (this.calendarView != null) {
    this.calendarView.remove();
    this.calendarView = null;
    if (navigateToBoard) {
      this.navigateToBoard();
    }
    $('.calendar-btn', this.$el).removeClass('board-header-btn-enabled');
    $('#board', this.$el).removeClass('hide');
    this.renderViewSwitcherDebounced();

    // Hack to resolve a bug where the lists won't have been
    // sized properly if the calendar was visible on initial
    // render (and the board and it's lists were hidden)
    $('.js-list-name-input', this.$el).trigger('autosize.resize', false);
  }
};

export const toggleMap = function () {
  sendPluginUIEvent({
    idPlugin: MAP_POWER_UP_ID,
    idBoard: this.model.id,
    event: {
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'powerUpBoardButton',
      source: 'boardScreen',
    },
  });
  if (this.mapView) {
    if (this.mapReturnCard) {
      this.closeMap(false);
      Controller.showCardDetail(this.mapReturnCard);
      return (this.mapReturnCard = null);
    } else {
      return this.navigateToBoardEvent();
    }
  } else {
    return this.navigateToMapEvent();
  }
};

export const navigateToMapEvent = function () {
  sendPluginScreenEvent({
    idPlugin: MAP_POWER_UP_ID,
    idBoard: this.model.id,
    screenName: 'boardMapPowerUpScreen',
  });
  return this.navigateToMap();
};

export const navigateToMap = function (centerTo, returnCard) {
  this.mapCenterTo = centerTo;
  this.mapReturnCard = returnCard;
  const mapBoardUrl = Controller.getBoardUrl(this.model.id, 'map');
  return navigate(mapBoardUrl, { trigger: true });
};

export const showMap = function ({ mapCenterTo, zoom }) {
  if (!this.model.isMapPowerUpEnabled() || this.mapView != null) {
    return;
  }

  $('.js-map-btn', this.$el).addClass('board-header-btn-enabled');
  $('#board', this.$el).addClass('hide');

  return importWithRetry(() =>
    import(/* webpackChunkName: "map-view" */ 'app/scripts/views/map/MapView'),
  ).then((module) => {
    const render = (mapCenterTo, zoom) => {
      this.mapView = new module.MapView({
        model: this.model,
        modelCache: this.modelCache,
        mapCenterTo: mapCenterTo ?? this.mapCenterTo,
        zoom: zoom ?? this.zoom,
      });
      $('.js-board-view-container', this.$el).html(this.mapView.render().el);
      return this.renderViewSwitcherDebounced();
    };

    // Reinitializes map view when theme changes.
    this.globalThemeObserver = new GlobalThemeObserver(() => {
      if (this.mapView) {
        render(this.mapView.mapCenterTo, this.mapView.zoom);
      }
    });

    render(mapCenterTo, zoom);
  });
};

export const closeMap = function (navigateToBoard) {
  if (this.globalThemeObserver) {
    this.globalThemeObserver.unsubscribe();
  }
  if (navigateToBoard == null) {
    navigateToBoard = true;
  }
  if (this.mapView != null) {
    this.mapView.remove();
    this.mapView = null;
    this.mapCenterTo = null;
    if (navigateToBoard) {
      this.navigateToBoard();
    }
    $('.js-map-btn', this.$el).removeClass('board-header-btn-enabled');
    $('#board', this.$el).removeClass('hide');
    $('.js-list-name-input', this.$el).trigger('autosize.resize', false);
    this.renderViewSwitcherDebounced();
  }
};

export const renderBoardHeaderMap = function () {
  // don't show the header button if map is a feature--it'll be in the switcher instead
  if (this.model.isMapCore()) {
    $('.js-map-btn', this.$el).addClass('hide');

    return;
  }

  if (this.model.isMapPowerUpEnabled()) {
    $('.js-map-btn', this.$el).removeClass('hide');
  } else {
    $('.js-map-btn', this.$el).addClass('hide');
  }
  return this;
};

export const showDashboard = async function () {
  $('#board', this.$el).addClass('hide');

  const board = this.model;

  const hasViewsFeature = board.isFeatureEnabled(PremiumFeature.Views);

  const canShowDashboard = hasViewsFeature;

  if (canShowDashboard) {
    const { BoardDashboardView } = await importWithRetry(() =>
      import(
        /* webpackChunkName: "board-dashboard-view" */ 'app/src/components/BoardDashboardView'
      ),
    );
    renderComponent(
      <BoardDashboardView
        idBoard={board.id}
        // eslint-disable-next-line react/jsx-no-bind
        navigateToBoardView={this.navigateToBoard.bind(this)}
      />,
      $('.js-board-view-container', this.$el).get(0),
    );
  } else {
    this.navigateToBoard();
  }
};

export const showPowerUpView = async function ({ idPlugin, viewKey }) {
  if (!this.model.isPluginEnabled(idPlugin)) {
    return;
  }

  const availableViews = await pluginRunner.one({
    plugin: idPlugin,
    command: 'board-views',
    board: this.model,
  });

  const selectedView = availableViews.find(
    (availableView) => availableView.key === viewKey,
  );

  if (!selectedView) {
    console.warn('Power-Up View not found.');
    this.navigateToBoard();
    return;
  }

  this.pluginView = new PluginViewView({
    model: this.model,
    content: selectedView,
  });

  $('#board', this.$el).addClass('hide');
  $('.js-board-view-container', this.$el).html(this.pluginView.render().el);
  this.renderViewSwitcherDebounced();
  this.renderBritaBoardFilterButtonDebounced();
};

export const closePowerUpView = function (navigateToBoard) {
  if (navigateToBoard == null) {
    navigateToBoard = true;
  }
  if (this.pluginView != null) {
    this.pluginView.remove();
    this.pluginView = null;
    if (navigateToBoard) {
      this.navigateToBoard();
    }
    $('#board', this.$el).removeClass('hide');
    $('.js-list-name-input', this.$el).trigger('autosize.resize', false);
  }
};

export const navigateToButler = function () {
  const butlerBoardUrl = Controller.getBoardUrl(this.model.id, 'butler');
  return navigate(butlerBoardUrl, { trigger: true });
};

/**
 * Navigates the user to butler-client for a given board with optional parameters
 * @param {string} idBoard the id of the board
 * @param {Object} [obj] optional Butler parameters
 * @param {ButlerTab | undefined} [obj.tab] the Butler tab to open
 * @param {string | undefined} [obj.edit] the Butler command to open in edit mode
 * @param {string | undefined} [obj.log] the Butler command log to open
 * @param {string | undefined} [obj.newCommand] the string (lz-compressed or not) for a new Butler command
 * @param {string | undefined} [obj.newIcon] the icon for a new Butler command
 * @param {string | undefined} [obj.newLabel] the label for a new Butler command
 * @param {string | undefined} [obj.taskId] the traceId of a capability to track opening the dashboard
 * @param {string | undefined} [obj.source] the source for the capability
 * @param {boolean} [trigger=true] whether to trigger navigation or just update the url
 */
export const navigateToButlerView = function (
  { tab, edit, log, newCommand, newIcon, newLabel, taskId, source } = {},
  trigger = true,
) {
  const params = {};
  if (newCommand) {
    params['c'] = newCommand;
    edit = 'new';
    if (newIcon) {
      params['i'] = newIcon;
    }
    if (newLabel) {
      params['l'] = newLabel;
    }
  }
  if (taskId) {
    params['taskId'] = taskId;
    params['source'] = source;
  }
  const butlerUrl = getButlerUrl(this.model.id, { tab, edit, log });
  const paramsString =
    newCommand || taskId ? `?${new URLSearchParams(params).toString()}` : '';
  navigate(`${butlerUrl}${paramsString}`, { trigger });
};

const getButlerUrl = function (
  idBoard,
  { tab = null, edit = null, log = null } = {},
) {
  const extras = [];
  if (tab) {
    extras.push(tab);
  }
  if (edit && edit === 'new' && tab) {
    extras.push('new');
  } else if (edit) {
    extras.push('edit', edit);
  } else if (log) {
    extras.push('log', log);
  }
  const boardUrl = Controller.getBoardUrl(idBoard, 'butler', extras);
  return boardUrl;
};

function isButlerViewActive() {
  return !!this.butlerView;
}
export { isButlerViewActive };

/**
 * Toggles the display of butler-client. If currently displayed, this will
 * close it; otherwise this will open it to the default tab
 */
export const toggleButlerView = function () {
  if (this.butlerView) {
    return this.closeButler();
  }
  const butlerUrl = getButlerUrl(this.model.id);
  return navigate(butlerUrl, { trigger: true });
};

/**
 * Creates and renders the butler view
 * this should only be called by showButlerView
 * @param {string} url iframe url for butler-client
 * @param {string | undefined} [taskId] the traceId of a capability to track opening the dashboard
 * @param {string | undefined} [source] the source for the capability
 */
export const setButlerView = function (url, taskId, source) {
  if (!isUrl(url)) {
    this.navigateToBoard();
    return;
  }
  $('#board', this.$el).addClass('hide');
  return importWithRetry(() =>
    import(
      /* webpackChunkName: "butler-view" */ 'app/scripts/views/butler/ButlerView'
    ),
  ).then(({ ButlerView }) => {
    if (this.butlerView) {
      this.butlerView.remove();
    }
    this.butlerView = new ButlerView({ butlerUrl: url });
    $('.board-canvas', this.$el).append(this.butlerView.render().el);
    if (taskId && source) {
      Analytics.taskSucceeded({
        taskName: 'view-butlerDashboard',
        traceId: taskId,
        source: source,
      });
    }
  });
};

/**
 * Retrieves the iframe url for butler-client
 * this should only be called by showBoardDetailView.
 * To open butler-client from elsewhere, either navigateToButlerView or
 * toggleButlerView should be used
 * @param {Object} [obj] optional Butler parameters
 * @param {string} [obj.butlerTab] the Butler tab to open
 * @param {string} [obj.butlerCmdEdit] the Butler command to open in edit mode
 * @param {string} [obj.butlerCmdLog] the Butler command log to open
 * @param {string} [obj.newCommand] the string (lz-compressed or not) for a new Butler command
 * @param {string} [obj.newIcon] the icon for a new Butler command
 * @param {string} [obj.newLabel] the label for a new Butler command
 * @param {string | undefined} [obj.taskId] the traceId of a capability to track opening the dashboard
 * @param {string | undefined} [obj.source] the source for the capability
 */
export const showButlerView = function ({
  butlerTab,
  butlerCmdEdit,
  butlerCmdLog,
  newCommand,
  newIcon,
  newLabel,
  taskId,
  source,
} = {}) {
  let traceId;
  let traceSource;
  if (this.butlerView != null) {
    return;
  }
  if (!this.model.editable()) {
    this.navigateToBoardEvent();
    return;
  }
  if (taskId) {
    // get rid of the taskId/source url parameters
    this.navigateToButlerView(
      {
        tab: butlerTab,
        edit: butlerCmdEdit,
        log: butlerCmdLog,
        newCommand,
        newIcon,
        newLabel,
      },
      false,
    );
    traceId = taskId;
    traceSource = source;
  } else {
    // no task Id, so this was probably a deep link
    traceSource = 'boardScreen';
    traceId = Analytics.startTask({
      taskName: 'view-butlerDashboard',
      source: traceSource,
    });
  }
  pluginRunner
    .one({
      plugin: BUTLER_POWER_UP_ID,
      command: 'show-settings',
      board: this.model,
      options: {
        butlerTab,
        butlerCmdEdit,
        butlerCmdLog,
        newCommand,
        newIcon,
        newLabel,
      },
    })
    .then((res) => {
      const showButler = this.model.canShowButlerUI();
      // In the case showButler is true lets open the Butler dashboard
      if (showButler) {
        return this.setButlerView(res, traceId, traceSource);
      }
      // Otherwise let's close the Butler dashboard and redirect them to the
      // board. They will still receive an alert letting them know that the
      // Butler dashboard has been restricted to only enterprise admins by their
      // Enterprise.
      this.closeButler();
      this.navigateToBoard();
    })
    .catch((error) => {
      Analytics.taskFailed({
        taskName: 'view-butlerDashboard',
        traceId: traceId,
        source: traceSource,
        error,
      });
      throw error;
    });
};

export const closeButler = function (navigateToBoard) {
  if (navigateToBoard == null) {
    navigateToBoard = true;
  }
  if (this.butlerView != null) {
    this.butlerView.remove();
    this.butlerView = null;
    if (navigateToBoard) {
      this.navigateToBoard();
    }
    $('#board', this.$el).removeClass('hide');
    $('.js-list-name-input', this.$el).trigger('autosize.resize', false);
  }
};
